import React from "react";

import language from "../../utils/language";
import { LANGUAGES, LANGUAGES_FIRMS } from "../../constants";
import api from "../../api";
import styles from "./LanguageSwitcher.scss";

class LanguageSwitcher extends React.Component {
  setRussianLanguage = async () => {
    this.setLanguage(LANGUAGES.rus);
  }

  setEnglishLanguage = async () => {
    this.setLanguage(LANGUAGES.eng);
  }

  setLanguage = lang => {
    if(window.setCulture){
      window.setCulture(lang);
    }
  };

  render() {
    return (
      <div className={styles.languageSwitcher}>
        <div className={styles.ru} onClick={this.setRussianLanguage} tabIndex={0} role="button">
          <div className={styles.icon} />
          <span className={styles.label}>RUS</span>
        </div>
        <div className={styles.en} onClick={this.setEnglishLanguage} tabIndex={0} role="button">
          <div className={styles.icon} />
          <span className={styles.label}>ENG</span>
        </div>
      </div>
    );
  }
}


export default LanguageSwitcher;
